<div
  class="wt-wren"
  #wren
  [class.wt-wren--docked]="docked()"
  [attr.aria-hidden]="docked() ? null : 'true'"
  [attr.role]="docked() ? 'button' : null"
  [attr.tabindex]="docked() ? 0 : null"
  [attr.aria-label]="docked() ? 'Open Ask Ryn' : null"
  (click)="onWrenActivate()"
  (keydown.enter)="onWrenActivate(); $event.preventDefault()"
  (keydown.space)="onWrenActivate(); $event.preventDefault()"
>
  <div class="wt-wren__sprite" #sprite [style.backgroundImage]="spriteUrl"></div>
</div>

@if (wayfindPrompt(); as prompt) {
<div
  class="wt-wren__prompt"
  [class.wt-wren__prompt--below]="prompt.below"
  [style.left.px]="prompt.x"
  [style.top.px]="prompt.y"
  role="status"
  aria-live="polite"
>
  {{ prompt.text }}
</div>
}
